<template>
    <v-form ref="form" @submit.prevent="submit" v-model="valid">
        <FormTitle class="pa-4 pt-0" dark
            >{{ program.title }}
            <template #subtitle
                >Register for upcoming events at Musicologie!</template
            >
        </FormTitle>

        <FormItem>
            <template #question>Which location?</template>
            <template #response
                ><SoliLocations
                    v-model="form.location_id"
                    autocomplete
                    hideDetails="auto"
                    :rules="rules_required" /></template
        ></FormItem>

        <FormItem>
            <template #question>Which event?</template>
            <template #response>
                <v-select
                    :items="program.group_events"
                    v-model="form.group_event_id"
                    :loading="apiEventsLoading"
                    rounded
                    outlined
                    dense
                    item-text="title"
                    item-value="id"
                    :label="
                        form.group_event_id ? program.title : 'Select an event'
                    "
                    hide-details="auto"
                    :rules="rules_required"
                    :menuProps="{
                        'max-width': 558,
                        'offset-y': true,
                    }"
                >
                    <template v-slot:[`item`]="{ item }">
                        <v-list>
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-subtitle>{{
                                        `Ages ${item.min_age}-${item.max_age}`
                                    }}</v-list-item-subtitle>
                                    <v-list-item-title>{{
                                        item.title
                                    }}</v-list-item-title>

                                    <v-list-item-subtitle>{{
                                        item.description
                                    }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item></v-list
                        >
                    </template></v-select
                >
            </template>
        </FormItem>

        <FormItem>
            <template #question>{{ `Which session?` }}</template>
            <template #response>
                <v-select
                    :items="apiEventRegisters"
                    v-model="form.event_register_id"
                    :loading="apiRegistersLoading"
                    no-data-text="Sorry! No available sessions for this event"
                    rounded
                    outlined
                    dense
                    item-text="dates"
                    item-value="id"
                    :label="
                        form.event_register_id
                            ? groupEvent?.title
                            : 'Select a session'
                    "
                    hide-details="auto"
                    :rules="[
                        (val) =>
                            !!form.location_id || 'Please select a location',
                        (val) => val !== null || 'This field is required',
                    ]"
                >
                    <template v-slot:[`item`]="{ item }">
                        <v-list>
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        item.dates
                                    }}</v-list-item-title>

                                    <v-list-item-subtitle>{{
                                        item.time
                                    }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>{{
                                        `with ${item.teacher.name}`
                                    }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item></v-list
                        >
                    </template></v-select
                >
            </template>
        </FormItem>

        <FormSubmit
            dark
            type="submit"
            :loading="loading"
            valid
            :errors="errors"
            gradient="gradient-orange"
            icon="send"
            text="Continue"
        ></FormSubmit>
    </v-form>
</template>

<script>
import FormRules from "../../Mixins/FormRules";
import FormItem from "../Form/FormItem.vue";
import FormTitle from "../Form/FormTitle.vue";
import FormSubmit from "../Form/FormSubmit.vue";

export default {
    mixins: [FormRules],
    components: {
        FormTitle,
        FormItem,
        FormSubmit,
    },
    props: {
        errors: {},
        program: {
            type: Object,
            default: () => {},
        },
        location: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            form: {
                location_id: this.location?.id ?? null,
                event_register_id: null,
                group_event_id: null,
            },
            apiEventRegisters: null,
            loading: false,
            valid: false,
            apiEventsLoading: false,
            apiRegistersLoading: false,
        };
    },
    methods: {
        setSingleEvent() {
            if (this.program.group_events.length !== 1) return;
            this.form.group_event_id = this.program.group_events[0].id;
        },
        getEventRegisters() {
            this.form.event_register_id = null;

            if (!this.form.location_id || !this.form.group_event_id) {
                this.apiEventRegisters = null;
                return;
            }

            this.apiRegistersLoading = true;

            axios
                .get(
                    `/api/event-registers/${this.form.location_id}/${this.form.group_event_id}`
                )
                .then((resp) => {
                    this.apiEventRegisters = resp.data;
                    this.apiRegistersLoading = false;
                    if (this.apiEventRegisters.length > 1) return;
                    this.form.event_register_id =
                        this.apiEventRegisters[0]?.id ?? null;
                });
        },
        submit() {
            if (!this.$refs.form.validate()) {
                this.$nextTick(() => {
                    const el = document.querySelector(
                        ".v-messages.error--text"
                    );
                    el.scrollIntoView({ block: "center" });
                });

                return;
            }
            this.loading = true;

            this.$inertia.get(
                route("eventRegistration.create", {
                    eventRegister: this.eventRegister.hash_id,
                })
            );
        },
        reset() {
            this.$refs.form.reset();
        },
    },
    computed: {
        groupEvent() {
            if (!this.form.group_event_id) return;
            return this.program.group_events.find(
                (e) => e.id == this.form.group_event_id
            );
        },
        eventRegister() {
            if (!this.form.event_register_id) return;
            return this.apiEventRegisters.find(
                (e) => e.id == this.form.event_register_id
            );
        },
    },
    mounted() {
        this.setSingleEvent();
        this.getEventRegisters();
    },
    watch: {
        "form.group_event_id": function () {
            this.getEventRegisters();
        },
        "form.location_id": function () {
            if (!this.form.group_event_id) return;
            this.getEventRegisters();
        },
    },
};
</script>
